export const TEXT_QUESTION_TYPES = Object.freeze(['long_text', 'short_text', 'statement']);

export const ANIMATION_SETTINGS = Object.freeze({
  DURATION: 0.5,
  SPRING_CONFIG: Object.freeze({ type: 'spring', visualDuration: 0.5, bounce: 0.1 }),
});

export const KEYBOARD_KEYS = Object.freeze({
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ENTER: 'Enter',
});

export const STORAGE_KEYS = Object.freeze({
  ANIMATION_DISABLED: 'isAnimationDisabled',
});
